import { useState, useEffect } from "react";
import { FileText, LogOut, Menu, User, X } from "lucide-react";
import Overview from "../../components/Dashboard siswa/Overview";
import MyClass from "../../components/Dashboard siswa/MyClass";
import Assessment from "../../components/Dashboard siswa/Assessment";
import Profile from "../../components/Dashboard siswa/Profile";
// import Sidebar from "@/components/Dashboard siswa/sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";

export const menuItems = [
  { name: "Overview", icon: <FileText size={20} /> },
  { name: "My Class", icon: <FileText size={20} /> },
  { name: "Assessment", icon: <FileText size={20} /> },
];

const DashboardSiswa = () => {
  const [activeTab, setActiveTab] = useState("Overview");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [user, setUser] = useState<any>(null);
  const location = useLocation();

  useEffect(() => {
    if (location.state?.tab) {
      setActiveTab(location.state.tab);
    }
  }, [location.state]);

  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Gagal memuat data user", error);
      }
    }
  }, []);

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (confirmLogout) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      navigate("/");
    }
  };

  const handleMenuClick = (tabName: string) => {
    setActiveTab(tabName);
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };

  const renderContent = () => {
    if (!user && activeTab !== "Overview")
      return <div className="p-8 text-center text-gray-500">Loading...</div>;

    switch (activeTab) {
      case "Overview":
        return <Overview />;
      case "My Class":
        return <MyClass />;
      case "Assessment":
        return <Assessment />;
      case "Profile":
        return <Profile user={user} />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className="flex min-h-screen bg-white font-sans text-gray-900 relative">
      {/* MOBILE OVERLAY */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed top-0 bottom-0 left-0 z-50 bg-white border-r border-gray-100 flex flex-col 
          transform transition-all duration-300 ease-in-out overflow-hidden
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
          lg:translate-x-0 lg:static lg:h-screen lg:inset-y-0
          /* LEBAR SIDEBAR: 80px saat collapsed */
          ${isCollapsed ? "lg:w-[80px]" : "lg:w-64"} 
        `}
      >
        {/* HEADER SIDEBAR (Logo & Toggle) */}
        <div
          className={`
            h-20 flex items-center mb-2 transition-all duration-300 w-full
            ${isCollapsed ? "justify-center px-0" : "justify-between px-6"}
          `}
        >
          {/* Logo - Hanya muncul jika tidak collapsed */}
          {!isCollapsed && (
            <Link to="/" className="flex items-center gap-2">
              <img
                src="/Fluenesia.png"
                alt="Fluenesia Logo"
                className="h-6 w-auto object-contain block"
              />
            </Link>
          )}

          {/* Tombol Hamburger (Menu) */}
          <button
            onClick={() => {
              if (window.innerWidth < 1024) {
                setIsSidebarOpen(false);
              } else {
                setIsCollapsed(!isCollapsed);
              }
            }}
            className={`
              text-gray-600 hover:text-[#B21318] transition rounded-lg hover:bg-gray-100 focus:outline-none flex items-center justify-center p-2
              ${!isCollapsed ? "mr-2" : ""}
            `}
          >
            <div className="lg:hidden">
              <X size={24} />
            </div>
            <div className="hidden lg:block">
              <Menu size={24} strokeWidth={2.5} />
            </div>
          </button>
        </div>

        {/* MENU ITEMS */}
        <nav className="flex-1 space-y-2 overflow-y-auto overflow-x-hidden px-4">
          <p
            className={`text-[10px] font-bold text-black uppercase mb-2 mt-4 tracking-wider transition-all duration-300 ${isCollapsed ? "text-center text-[9px]" : "px-2"}`}
          >
            Dashboard
          </p>

          {menuItems.map((item) => (
            <button
              key={item.name}
              onClick={() => handleMenuClick(item.name)}
              title={isCollapsed ? item.name : ""}
              className={`
                group w-full flex items-center py-3 rounded-2xl font-medium transition-all duration-300 relative
                ${isCollapsed ? "justify-center px-0" : "justify-start px-4 gap-3"}
                ${activeTab === item.name ? "bg-[#FF0000] text-white shadow-md shadow-red-200" : "text-gray-400 hover:bg-gray-50 hover:text-gray-600"}
              `}
            >
              <div className="shrink-0">{item.icon}</div>

              <span
                className={`text-sm whitespace-nowrap transition-all duration-300 ${isCollapsed ? "w-0 opacity-0 hidden" : "w-auto opacity-100 block"}`}
              >
                {item.name}
              </span>

              {/* Tooltip Hover saat Collapsed */}
              {isCollapsed && (
                <div className="absolute left-14 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 whitespace-nowrap">
                  {item.name}
                </div>
              )}
            </button>
          ))}

          <div className="pt-6">
            <p
              className={`text-[10px] font-bold text-black uppercase mb-2 tracking-wider transition-all duration-300 ${isCollapsed ? "text-center text-[9px]" : "px-2"}`}
            >
              Account
            </p>

            <button
              onClick={() => handleMenuClick("Profile")}
              title={isCollapsed ? "Profile" : ""}
              className={`
                group w-full flex items-center py-3 rounded-2xl font-medium transition-all duration-300
                ${isCollapsed ? "justify-center px-0" : "justify-start px-4 gap-3"}
                ${activeTab === "Profile" ? "bg-[#FF0000] text-white shadow-md shadow-red-200" : "text-gray-400 hover:bg-gray-50 hover:text-gray-600"}
              `}
            >
              <div className="shrink-0">
                <User size={20} />
              </div>
              <span
                className={`text-sm whitespace-nowrap transition-all duration-300 ${isCollapsed ? "w-0 opacity-0 hidden" : "w-auto opacity-100 block"}`}
              >
                Profile
              </span>
            </button>

            <button
              onClick={handleLogout}
              title={isCollapsed ? "Logout" : ""}
              className={`
                w-full flex items-center py-3 rounded-2xl font-medium text-red-600 mt-2 hover:bg-red-50 transition-all duration-300
                ${isCollapsed ? "justify-center px-0" : "justify-start px-4 gap-3"}
              `}
            >
              <div className="shrink-0">
                <LogOut size={20} />
              </div>
              <span
                className={`text-sm whitespace-nowrap transition-all duration-300 ${isCollapsed ? "w-0 opacity-0 hidden" : "w-auto opacity-100 block"}`}
              >
                Logout
              </span>
            </button>
          </div>
        </nav>
      </aside>

      <main
        className={`flex-1 w-full bg-white min-h-screen transition-all duration-300 ${isCollapsed ? "lg:ml-[80px]" : "lg:ml-auto"}`}
      >
        <header className="flex justify-between lg:justify-end p-4 lg:p-6 items-center sticky top-0 bg-white/90 backdrop-blur-sm z-30 border-b lg:border-none border-gray-100">
          <button
            onClick={() => setIsSidebarOpen(true)}
            className="p-2 -ml-2 text-gray-600 hover:bg-gray-100 rounded-lg lg:hidden"
          >
            <Menu size={24} />
          </button>

          {user && (
            <div className="flex items-center gap-3 px-2 lg:px-4 py-2 rounded-full hover:bg-gray-50 transition-all cursor-pointer">
              <div className="flex flex-col items-end leading-tight">
                <span className="font-bold text-sm text-gray-800 text-right whitespace-nowrap">
                  {user.name}
                </span>
                <span className="text-[10px] text-gray-500 uppercase font-medium">
                  {user.role || "Student"}
                </span>
              </div>
              <div className="w-9 h-9 bg-[#B21318] rounded-full flex items-center justify-center text-white text-sm font-bold shadow-sm uppercase shrink-0">
                {user.name.charAt(0)}
              </div>
            </div>
          )}
        </header>

        <div className="max-w-5xl mx-auto px-4 lg:px-8 pb-12">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default DashboardSiswa;
